/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Editor_Date_Of_BirthInputs */

const en_resume_editor_date_of_birth = /** @type {(inputs: Resume_Editor_Date_Of_BirthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date of Birth`)
};

const de_resume_editor_date_of_birth = /** @type {(inputs: Resume_Editor_Date_Of_BirthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geburtsdatum`)
};

const fr_resume_editor_date_of_birth = /** @type {(inputs: Resume_Editor_Date_Of_BirthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date de naissance`)
};

const es_resume_editor_date_of_birth = /** @type {(inputs: Resume_Editor_Date_Of_BirthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de nacimiento`)
};

const it_resume_editor_date_of_birth = /** @type {(inputs: Resume_Editor_Date_Of_BirthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data di nascita`)
};

const nl_resume_editor_date_of_birth = /** @type {(inputs: Resume_Editor_Date_Of_BirthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geboortedatum`)
};

const pl_resume_editor_date_of_birth = /** @type {(inputs: Resume_Editor_Date_Of_BirthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data urodzenia`)
};

const fi_resume_editor_date_of_birth = /** @type {(inputs: Resume_Editor_Date_Of_BirthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Syntymäaika`)
};

const da_resume_editor_date_of_birth = /** @type {(inputs: Resume_Editor_Date_Of_BirthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fodselsdato`)
};

const sv_resume_editor_date_of_birth = /** @type {(inputs: Resume_Editor_Date_Of_BirthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fodelsedatum`)
};

/**
* | output |
* | --- |
* | "Date of Birth" |
*
* @param {Resume_Editor_Date_Of_BirthInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resume_editor_date_of_birth = /** @type {((inputs?: Resume_Editor_Date_Of_BirthInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Editor_Date_Of_BirthInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resume_editor_date_of_birth(inputs)
	if (locale === "fr") return fr_resume_editor_date_of_birth(inputs)
	if (locale === "es") return es_resume_editor_date_of_birth(inputs)
	if (locale === "it") return it_resume_editor_date_of_birth(inputs)
	if (locale === "nl") return nl_resume_editor_date_of_birth(inputs)
	if (locale === "pl") return pl_resume_editor_date_of_birth(inputs)
	if (locale === "fi") return fi_resume_editor_date_of_birth(inputs)
	if (locale === "da") return da_resume_editor_date_of_birth(inputs)
	if (locale === "sv") return sv_resume_editor_date_of_birth(inputs)
	return en_resume_editor_date_of_birth(inputs)
});